import React, { useEffect } from "react";

function getYearsFromDate(dateString) {
  const startDate = new Date(dateString);
  const today = new Date();

  let years = today.getFullYear() - startDate.getFullYear();

  // Birthday/anniversary hasn't happened yet this year
  const hasPassed =
    today.getMonth() > startDate.getMonth() ||
    (today.getMonth() === startDate.getMonth() &&
      today.getDate() >= startDate.getDate());

  if (!hasPassed) {
    years--;
  }

  return years;
}

const PageImage = () => {
  return (
    <div>
      <img
        src="images/018.jpg"
        className="img-fluid"
        alt=""
        width="600"
        height="345"
      />
      <br />
      <br />
      <br />
    </div>
  );
};

const PageText = () => {
  const years = getYearsFromDate("1987-01-01");

  return (
    <div className="text-responsive">
      <h2>Contemporary Italian Womenswear</h2>

      <h3>By Appointment</h3>

      <p>
        Over the past {years} years, Donatella Signorini has built an exclusive
        multi-brand boutique, offering clients direct access to rare, niche
        designers from Florence and Milan.
      </p>

      <p>
        Welcoming clients by appointment only to her private Chelsea studio,
        Donatella provides a calm, highly personalized alternative to
        high-street retail. She develops a deep understanding of each client's
        individual style, offering expert guidance on fit, color, and wardrobe
        coordination frequently tailoring looks for business leaders, media, and
        public figures.
      </p>

      <p>
        Her serene studio accented by her personal collection of modern art,
        ceramics, and textiles is an inspiring space defined by discretion,
        exceptional Italian craftsmanship, and timeless elegance.
      </p>

    </div>
  );
};

const Index = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);
  return (
    <div className="container-fluid">
      <div className="row page-row">
        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-center">
          <PageImage />
        </div>

        <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-left">
          <PageText />
        </div>
      </div>
    </div>
  );
};

export default Index;
